import { render } from "./TableFooter.vue?vue&type=template&id=5a6149e2"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"
script.render = render

export default script